<p-dialog
  *ngIf="visible"
  [header]="header"
  [style]="{ width: '750px', height: '480px' }"
  [(visible)]="visible"
  modal="modal"
  [closeOnEscape]="false"
  [focusOnShow]="false"
  appendTo="body"
  [resizable]="false"
  [closable]="false"
  styleClass="wizard__dialog"
>
  <kpd-spinner type="overlay" *ngIf="applicationConfirmed && (importLoading$ | async)"></kpd-spinner>
  <kpd-action
    class="wizard__dialog-close"
    icon="times"
    [disable]="importLoading$ | async"
    (action)="close(activeStep > 1 ? verify : cancel)"
  ></kpd-action>
  <kpd-wizard [title]="'Select template(s)' | translate" [activeStep]="activeStep">
    <kpd-wizard-step [header]="'Select application' | translate" [error]="applicationError">
      <form [formGroup]="form" class="permissionset-import__form">
        <div class="flex-row flex-wrap form--no-margin-right">
          <div class="flex-column form__column">
            <div class="form flex-row">
              <kpd-alert type="error" *ngIf="applicationError" icon="error-standard" class="full-width">
                {{ applicationError }}
              </kpd-alert>
            </div>
            <div class="form__control flex-row">
              <label>{{ 'Application' | translate }}:</label>
              <div class="form__input">
                <kpd-data-lookup
                  [items]="applications"
                  formControlName="application"
                  [title]="'Application'"
                  [displayField]="'name'"
                  [searchField]="'name'"
                  [valueField]="'name'"
                  [name]="'application'"
                  [columns]="applicationColumns"
                  (valueChanged)="onApplicationChange()"
                >
                </kpd-data-lookup>
              </div>
            </div>
          </div>
        </div>
      </form>
      <ng-template kpdTemplate="footer">
        <button class="button button--outline" (click)="close()" translate>Cancel</button>
        <button class="button button--main" (click)="onConfirmApplication()" translate>Next</button>
      </ng-template>
    </kpd-wizard-step>
    <kpd-wizard-step [header]="'Select template(s)' | translate">
      <kpd-spinner type="overlay" *ngIf="importLoading$ | async"></kpd-spinner>
      <div *ngIf="!(importLoading$ | async) && permissionSetsTree && permissionSetsTree.length === 0">
        No permissionsets found to update
      </div>
      <div
        class="permissionsets-tree permissionsets-tree--checkbox "
        *ngIf="permissionSetsTree && permissionSetsTree.length > 0"
      >
        <div class="permissionsets-tree__title">
          <span
            ><input
              type="checkbox"
              [checked]="permissionSetsTree.length === permissionSetSelectionCount"
              (change)="onCheckboxChangeAll($event)"
          /></span>
          <h3 translate>Permission sets</h3>
          <h3 translate>Import as</h3>
        </div>

        <div *ngIf="permissionSetsTree && permissionSetsTree.length > 0">
          <p-tree
            [value]="permissionSetsTree"
            [(selection)]="permissionSetSelection"
            (onNodeExpand)="onNodeExpand($event)"
          >
            <ng-template let-node pTemplate="notFound">
              <clr-icon shape="info" class="permissionsets-tree__icon"></clr-icon>
              <span>{{ node.label }}</span>
            </ng-template>
            <ng-template let-node pTemplate="default">
              <div>
                <div class="branch branch--selectOptions" *ngIf="!node.leaf">
                  <input
                    type="checkbox"
                    class="checkbox"
                    [checked]="!!permissionSetSelection[node.data.key.toString()]"
                    (change)="onCheckboxChange($event, node)"
                  />
                  <span>{{ node.label }}</span>
                  <p-selectButton
                    [options]="selectOptions"
                    multiple="multiple"
                    [(ngModel)]="node.data.types"
                    (onChange)="onSelectButtonChange($event, node)"
                  ></p-selectButton>
                </div>
                <div class="leaf" *ngIf="node.leaf">
                  <span>{{ node.label }}</span>
                  <span
                    class="state-tag state-tag--deprecated"
                    [attr.title]="node.data.deprecatedMessage"
                    *ngIf="node.data && node.data.isDeprecated"
                    translate
                    >Deprecated</span
                  >
                </div>
              </div>
            </ng-template>
          </p-tree>
        </div>
      </div>
      <ng-template kpdTemplate="footer">
        <button class="button button--outline" (click)="close()" translate>Cancel</button>
        <button
          class="button button--main"
          (click)="onStartImport()"
          [disabled]="permissionSetSelectionCount === 0"
          translate
        >
          Import
        </button>
      </ng-template>
    </kpd-wizard-step>
    <kpd-wizard-step
      [header]="'Import' | translate"
      [success]="!(importLoading$ | async) && feedbackAllSucceeded"
      [error]="!(importLoading$ | async) && feedbackHasErrors"
    >
      <div class="permissionset-import">
        <div class="spinner__icon">
          <kpd-spinner type="inline" *ngIf="importLoading$ | async"></kpd-spinner>
          <clr-icon *ngIf="!(importLoading$ | async) && feedbackAllSucceeded" shape="check"></clr-icon>
          <clr-icon *ngIf="!(importLoading$ | async) && feedbackHasErrors" shape="times"></clr-icon>
        </div>
        <h3 class="spinner__message">
          <span *ngIf="importLoading$ | async"
            ><span translate>Import</span> {{ feedback.length + 1 }} <span translate>of</span>
            {{ countOfSetsToImport }} ...</span
          >
          <span *ngIf="!(importLoading$ | async) && feedbackAllSucceeded" translate>Import successful</span>
          <span *ngIf="!(importLoading$ | async) && feedbackHasErrors"
            ><span translate>Import failed for</span> {{ importErrors.length }} <span translate>items</span></span
          >
        </h3>
        <div class="spinner__feedback" #feedbackScroll>
          <span *ngFor="let item of sortedFeedback" class="spinner__feedback-item">
            <clr-icon [attr.shape]="item.success ? 'check' : 'times'"></clr-icon>
            {{ item.name }}
            <div class="spinner__feedback-error" *ngIf="!item.success">
              <clr-icon shape="error-standard"></clr-icon>
              {{ item.message }}
            </div>
          </span>
        </div>
        <ng-template kpdTemplate="footer">
          <button class="button button--main" [disabled]="importLoading$ | async" (click)="close(verify)" translate>
            Finish
          </button>
        </ng-template>
      </div>
    </kpd-wizard-step>
  </kpd-wizard>
</p-dialog>
